/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class InfiniteScroll extends HTMLElement {
  static _isRestoring = false;
  constructor() {
    super();
    const currentPage = InfiniteScroll.getCurrentPageFromUrl();
    if (currentPage > 1 && !InfiniteScroll._isRestoring) {
      const hasPreviousPages = document.querySelector('#product-grid .grid__item[data-page="1"]');
      if (!hasPreviousPages) {
        InfiniteScroll._isRestoring = true;
      }
    }
    this.addEventListener('click', this.onClickHandler.bind(this));
    if (this.dataset.trigger === 'infinite') {
      this._infiniteScrollObserver = this._createObserver(this.handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px'
      });
      this._infiniteScrollObserver.observe(this);
    }
  }
  disconnectedCallback() {
    if (this._infiniteScrollObserver) this._infiniteScrollObserver.disconnect();
    if (this._intersectionObserver) this._intersectionObserver.disconnect();
  }
  _createObserver(callback, options = {}) {
    return new IntersectionObserver(callback, options);
  }
  observeGridItemsForPageUpdate() {
    if (this._intersectionObserver) {
      this._intersectionObserver.disconnect();
    }
    if (!document.querySelector('#product-grid .grid__item[data-page]')) {
      return;
    }
    this._intersectionObserver = this._createObserver(() => {
      if (window.scrollY + window.innerHeight < document.body.scrollHeight - 1500) {
        const visibleItems = Array.from(document.querySelectorAll('#product-grid .grid__item[data-page]')).filter(item => {
          const rect = item.getBoundingClientRect();
          return rect.bottom > 0 && rect.top < window.innerHeight;
        });
        const midpoint = window.innerHeight / 2;
        let maxPage = -1;
        let closest = null;
        let minDist = Infinity;
        visibleItems.forEach(item => {
          const rect = item.getBoundingClientRect();
          const page = parseInt(item.getAttribute('data-page'), 10);
          const itemMid = rect.top + rect.height / 2;
          const distToMidpoint = Math.abs(itemMid - midpoint);
          if (page < maxPage) return;
          if (page > maxPage || distToMidpoint < minDist) {
            maxPage = page;
            minDist = distToMidpoint;
            closest = item;
          }
        });
        if (closest) {
          const page = parseInt(closest.getAttribute('data-page'), 10);
          const currentPage = InfiniteScroll.getCurrentPageFromUrl();
          if (!isNaN(page) && page !== currentPage) {
            InfiniteScroll.setPageInUrl(page, {
              replace: true
            });
          }
        }
      }
    }, {
      threshold: [0, 0.5, 1]
    });
    document.querySelectorAll('#product-grid .grid__item[data-page]').forEach(item => {
      this._intersectionObserver.observe(item);
    });
  }
  onClickHandler() {
    if (InfiniteScroll._isRestoring) {
      return;
    }
    const loading_container = document.getElementById('ProductGridContainer')?.querySelector('.collection');
    if (loading_container.classList.contains('loading') || this.classList.contains('loading') || this.classList.contains('disabled')) return;
    this.classList.add('loading', 'disabled');
    const url = this.dataset.url;
    InfiniteScroll.renderSectionFromFetch(url).then(() => {
      this.classList.remove('loading', 'disabled');
    }).finally(() => {
      this.observeGridItemsForPageUpdate();
    });
  }
  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    if (InfiniteScroll._isRestoring) {
      return;
    }
    observer.unobserve(this);
    this.onClickHandler();
  }
  static renderSectionFromFetch(url) {
    return fetch(url).then(response => response.text()).then(responseText => {
      const html = responseText;
      InfiniteScroll.renderPagination(html);
      InfiniteScroll.renderProductGridContainer(html);
      InfiniteScroll.updateUrlWithPage();
      const pageAddedEvent = new CustomEvent('infinite-scroll:page-added', {
        bubbles: true,
        detail: {
          url: url,
          html: html
        }
      });
      document.dispatchEvent(pageAddedEvent);
    }).catch(e => {
      console.error(e);
    });
  }
  static renderPagination(html) {
    const container = document.getElementById('ProductGridContainer')?.querySelector('.pagination-wrapper');
    const pagination = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer')?.querySelector('.pagination-wrapper');
    if (pagination && container) {
      container.innerHTML = pagination.innerHTML;
    } else if (container) {
      container.remove();
    }
  }
  static renderProductGridContainer(html) {
    const container = document.getElementById('product-grid');
    const productGrid = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
    if (!productGrid || !container) return;
    const gridItems = productGrid.querySelectorAll('.grid__item');
    const page = InfiniteScroll.getCurrentPageFromUrl();
    const existingProductCards = container.querySelectorAll('.product-card[data-item-index]');
    let nextIndex = existingProductCards.length;
    gridItems.forEach(item => {
      item.setAttribute('data-page', page + 1);
      const productCard = item.querySelector('.product-card[data-item-index]');
      if (productCard) {
        productCard.setAttribute('data-item-index', nextIndex);
        nextIndex++;
      }
    });
    container.insertAdjacentHTML('beforeend', productGrid.innerHTML);
  }
  static updateUrlWithPage() {
    const page = InfiniteScroll.getCurrentPageFromUrl() + 1;
    InfiniteScroll.setPageInUrl(page, {
      replace: false
    });
  }
  static getCurrentPageFromUrl() {
    return parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
  }
  static setPageInUrl(page, {
    replace = false
  } = {}) {
    const url = new URL(window.location.href);
    if (page === 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', page);
    }
    if (replace) {
      window.history.replaceState({}, '', url.toString());
    } else {
      window.history.pushState({}, '', url.toString());
    }
  }
  static getUrlForPage(page) {
    const url = new URL(window.location.href);
    if (page === 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', String(page));
    }
    return url.toString();
  }
  static scrollToProductHandle(handle) {
    if (!handle) return;
    const productEl = document.querySelector(`.grid__item[data-product-handle="${CSS.escape(handle)}"]`);
    if (!productEl) return;
    const rect = productEl.getBoundingClientRect();
    const elementMiddle = rect.top + window.scrollY + rect.height / 2;
    const viewportMiddle = window.innerHeight / 2;
    const scrollToPosition = elementMiddle - viewportMiddle;
    window.scrollTo({
      top: scrollToPosition,
      behavior: 'auto'
    });
  }
  static renumberItemIndexes() {
    const productCards = document.querySelectorAll('#product-grid .product-card[data-item-index]');
    productCards.forEach((card, index) => {
      card.setAttribute('data-item-index', String(index));
    });
  }
  static async restoreInfiniteScrollState({
    targetPage,
    lastClickedHandle
  }) {
    if (!targetPage || targetPage <= 1) {
      if (lastClickedHandle) {
        InfiniteScroll.scrollToProductHandle(lastClickedHandle);
      }
      return;
    }
    const container = document.getElementById('product-grid');
    if (!container) return;
    const pagesToLoad = [];
    for (let p = 1; p < targetPage; p++) pagesToLoad.push(p);
    try {
      const pageHtmlList = await Promise.all(pagesToLoad.map(p => fetch(InfiniteScroll.getUrlForPage(p)).then(r => r.text()).then(html => ({
        page: p,
        html
      }))));
      pageHtmlList.sort((a, b) => b.page - a.page).forEach(({
        page,
        html
      }) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const productGrid = parsed.getElementById('product-grid');
        if (!productGrid) return;
        const gridItems = productGrid.querySelectorAll('.grid__item');
        gridItems.forEach(item => {
          item.setAttribute('data-page', String(page));
        });
        container.insertAdjacentHTML('afterbegin', productGrid.innerHTML);
      });
      InfiniteScroll.renumberItemIndexes();
      requestAnimationFrame(() => {
        if (lastClickedHandle) {
          InfiniteScroll.scrollToProductHandle(lastClickedHandle);
        } else {
          const firstItemOfTargetPage = container.querySelector(`.grid__item[data-page="${targetPage}"]`);
          if (firstItemOfTargetPage) {
            firstItemOfTargetPage.scrollIntoView({
              block: 'start',
              behavior: 'auto'
            });
          }
        }
        requestAnimationFrame(() => {
          InfiniteScroll._isRestoring = false;
        });
      });
      document.querySelector('infinite-scroll')?.observeGridItemsForPageUpdate();
    } catch (error) {
      console.error('Error restoring infinite scroll state:', error);
      InfiniteScroll._isRestoring = false;
    }
  }
}
customElements.define('infinite-scroll', InfiniteScroll);
window.addEventListener('pageshow', event => {
  const targetPage = InfiniteScroll.getCurrentPageFromUrl();
  if (targetPage <= 1) return;
  const isBfCacheRestore = event.persisted;
  const navEntry = performance.getEntriesByType('navigation')[0];
  const isBackFromNavigation = navEntry && navEntry.type === 'back_forward';
  const lastClickedProductHandle = sessionStorage.getItem('lastClickedProductHandle');
  if (isBfCacheRestore) {
    setTimeout(() => {
      if (lastClickedProductHandle) {
        InfiniteScroll.scrollToProductHandle(lastClickedProductHandle);
        sessionStorage.removeItem('lastClickedProductHandle');
      }
      InfiniteScroll._isRestoring = false;
    }, 50);
    return;
  }
  if (isBackFromNavigation && lastClickedProductHandle) {
    InfiniteScroll.restoreInfiniteScrollState({
      targetPage,
      lastClickedHandle: lastClickedProductHandle
    }).finally(() => {
      sessionStorage.removeItem('lastClickedProductHandle');
    });
  } else {
    InfiniteScroll.restoreInfiniteScrollState({
      targetPage,
      lastClickedHandle: null
    });
  }
});
document.getElementById('product-grid')?.addEventListener('click', e => {
  const link = e.target.closest('a[href*="/products/"]');
  if (!link) return;
  const productItem = link.closest('.grid__item[data-product-handle]');
  if (!productItem) return;
  const handle = productItem.dataset.productHandle;
  sessionStorage.setItem('lastClickedProductHandle', handle);
});
/******/ })()
;